import { Drawer, List } from "antd";
import Avatar from "../../../../../../components/generic/Avatar";
import { getContactDetails } from "./helper";

const ContactDrawer = ({ onClose, contacts }) => {
  return (
    <Drawer
      className="contact-drawer"
      placement="right"
      open
      onClose={onClose}
      title={`${contacts.length} Contact${contacts.length !== 1 ? "s" : ""}`}
    >
      <List
        itemLayout="horizontal"
        dataSource={contacts}
        renderItem={(item) => {
          const { fullFirstName, fullLastName, phoneNumber } =
            getContactDetails(item);

          return (
            <List.Item
              actions={[
                <div
                  className="cursor-pointer"
                  key="call"
                  onClick={(e) => {
                    e.stopPropagation();
                    window.location.href = `tel:${item?.phoneNumbers?.[0]?.number}`;
                  }}
                  style={{
                    fontSize: 22,
                    color: "black",
                  }}
                >
                  📞
                </div>,
              ]}
            >
              <List.Item.Meta
                avatar={
                  <Avatar
                    user={{
                      first_name: fullFirstName,
                      last_name: fullLastName,
                    }}
                    size={40}
                  />
                }
                title={
                  <span
                    style={{
                      fontSize: 16,
                      fontWeight: 600,
                      color: "#0F172A",
                    }}
                  >
                    {item?.name}
                  </span>
                }
                description={
                  <div
                    style={{
                      fontSize: 13,
                      color: "#64748B",
                      marginTop: "-3px",
                    }}
                  >
                    {phoneNumber}
                  </div>
                }
                style={{
                  alignItems: "center",
                }}
              />
            </List.Item>
          );
        }}
      />
    </Drawer>
  );
};

export default ContactDrawer;
